module.exports = __webpack_public_path__ + "media/customizations/woodcreek/back-c5236787ad14da72675eacfe05034df3.jpg";